import React from "react";
import { Button, Col, DatePicker, Input, Row, Select, Upload, Switch } from "antd";
import { Controller, useFormContext } from "react-hook-form";
import { UploadOutlined } from "@ant-design/icons";
import UploadField from "../UploadField";
import Error from "./Error";
import dayjs from "dayjs";
const CoApplicant = ({ id, ocfDisplayId }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const colProps = { xs: 24, sm: 12, md: 12, lg: 8 };

  return (
    <Row gutter={[16, 16]} style={{ margin: "28px 0" }}>
      {/* <Col span={8} {...colProps}>
        <div className="form-field">
          <label className="form-label">Co-Applicant Available</label>
          <Controller
            name="coApplicant.available"
            control={control}
            render={({ field }) => <Switch checked={field.value} onChange={field.onChange} />}
          />
        </div>
      </Col> */}

      {/* {available && ( */}
      <>
        {/* Name */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Co-Applicant Name</label>
            <Controller
              name="coApplicant.name"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.name && "error"} />
              )}
            />
            <Error name="coApplicant.name" />
          </div>
        </Col>
        {/* Father/Husband */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Father/Husband Name</label>
            <Controller
              name="coApplicant.careOfName"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.careOfName && "error"} />
              )}
            />
            <Error name="coApplicant.careOfName" />
          </div>
        </Col>
        {/* Email (optional) */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Email (Optional)</label>
            <Controller
              name="coApplicant.email"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.email && "error"} />
              )}
            />
            <Error name="coApplicant.email" />
          </div>
        </Col>
        {/* Gender */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Gender</label>
            <Controller
              name="coApplicant.gender"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  style={{ width: "100%" }}
                  placeholder="Select gender"
                  status={errors.coApplicant?.gender && "error"}
                >
                  <Select.Option value="M">Male</Select.Option>
                  <Select.Option value="F">Female</Select.Option>
                </Select>
              )}
            />
            <Error name="coApplicant.gender" />
          </div>
        </Col>
        {/* Mobile */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Mobile</label>
            <Controller
              name="coApplicant.mobile"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.mobile && "error"} />
              )}
            />
            <Error name="coApplicant.mobile" />
          </div>
        </Col>
        {/* Alternate Mobile */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Alternate Number (Optional)</label>
            <Controller
              name="coApplicant.mobile2"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.mobile2 && "error"} />
              )}
            />
            <Error name="coApplicant.mobile2" />
          </div>
        </Col>
        {/* DOB */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Date of Birth</label>
            <Controller
              name="coApplicant.dob"
              control={control}
              render={({ field }) => (
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(date) => field.onChange(date ? date.format("YYYY-MM-DD") : null)}
                  status={errors.coApplicant?.dob && "error"}
                />
              )}
            />
            <Error name="coApplicant.dob" />
          </div>
        </Col>
        {/* Profession */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Profession (Optional)</label>
            <Controller
              name="coApplicant.profession"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.profession && "error"} />
              )}
            />
            <Error name="coApplicant.profession" />
          </div>
        </Col>
        {/* Address */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Address</label>
            <Controller
              name="coApplicant.address"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.address && "error"} />
              )}
            />
            <Error name="coApplicant.address" />
          </div>
        </Col>
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Relation with Applicant</label>
            <Controller
              name="coApplicant.relationWithApplicant"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.relationWithApplicant && "error"} />
              )}
            />
            <Error name="coApplicant.relationWithApplicant" />
          </div>
        </Col>

        {/* Aadhar */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Aadhar Number</label>
            <Controller
              name="coApplicant.aadhar"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.aadhar && "error"} />
              )}
            />
            <Error name="coApplicant.aadhar" />
            <UploadField
              name="coApplicant.aadharFile"
              fieldType="coapplicant_aadhar"
              label="Copy of Aadhar File"
              ocfDisplayId={ocfDisplayId}
            />
            <Error name="coApplicant.aadharFile" />
          </div>
        </Col>
        {/* PAN */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">PAN Number</label>
            <Controller
              name="coApplicant.pan"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.coApplicant?.pan && "error"} />
              )}
            />
            <Error name="coApplicant.pan" />

            <UploadField
              name="coApplicant.panFile"
              fieldType="coApplicant_pan"
              label="Copy of Pan Card"
              ocfDisplayId={ocfDisplayId}
            />
            <Error name="coApplicant.panFile" />
          </div>
        </Col>
      </>
      {/* )} */}
    </Row>
  );
};

export default CoApplicant;
